<template>
  <div id="question-details">
    <!-- 查看错题集/收藏夹中的试题详情 -->
    <div class="question-title">
      <span v-html="data.questionStem"></span>
      <span class="nd"
        >（难度：<i
          :class="{
            'el-icon-star-off': true,
            'el-icon-star-on': data.gradeOfDifficulty >= s,
          }"
          v-for="s in 5"
          :key="s"
        ></i
        >）</span
      >
    </div>
    <div class="xx" v-if="data.topicnType == '0'">
      <!-- 选择题的选项值 -->
      <el-radio-group v-model="data.answer">
        <el-radio
          class="itel"
          :label="qo.title"
          v-for="(qo, iii) in data.questionOptions"
          :key="iii"
        >
          <span style="font-weight: bold">{{ qo.title }}、</span>
          <span v-html="qo.value"></span>
        </el-radio>
      </el-radio-group>
    </div>
    <div class="xx" v-if="data.topicnType == '1'">
      <!-- 选择题的选项值 -->
      <el-checkbox-group v-model="data.answer">
        <el-checkbox
          class="itel"
          :label="qo.title"
          v-for="(qo, iii) in data.questionOptions"
          :key="iii"
        >
          <span style="font-weight: bold">{{ qo.title }}、</span
          ><span v-html="qo.value"></span>
        </el-checkbox>
      </el-checkbox-group>
    </div>
    <div class="da" v-if="type == '0'">
      <div class="ti">【您的答案】:</div>
      <div class="tv" v-if="data.topicnType == '0'">
        <!-- 单选 -->
        <span class="answer">{{ data.answer }}</span>
      </div>
      <div class="tv" v-if="data.topicnType == '1'">
        <!-- 多选 -->
        <span v-for="(item, index) in data.answer" :key="index" class="answer"
          ><span v-if="index > 0">,</span>{{ item }}</span
        >
      </div>
      <div class="tv pd" v-if="data.topicnType == '2'">
        <!-- 填空 -->
        <div
          :class="{ li: true }"
          v-for="(item, index) in data.answer"
          :key="index"
        >
          <div class="title">{{ item.title }}:</div>
          <div
            :class="{ 'li-va': true, answer: true }"
            v-html="item.htmlValue"
          ></div>
        </div>
      </div>
      <div class="tv" v-if="data.topicnType == '3'">
        <!-- 判断 -->
        <el-radio-group
          v-model="data.answer"
          class="div-flex-center div-flex-start"
        >
          <el-radio :label="'0'">
            <i class="el-icon-check"></i>
          </el-radio>
          <el-radio :label="'1'">
            <i class="el-icon-close"></i>
          </el-radio>
        </el-radio-group>
      </div>
      <div class="tv pd" v-if="data.topicnType == '4'">
        <!-- 简答题 -->
        <div class="li">
          <div
            :class="{ 'li-va': true, answer: true }"
            v-html="data.answer[0].htmlValue"
          ></div>
        </div>
      </div>
    </div>
    <div class="da1">
      <div class="ti">【标准答案】:</div>
      <div class="tv" v-if="data.topicnType == '0'">
        <!-- 单选 -->
        <span>{{ data.questionAnswer[0].value }}</span>
      </div>
      <div class="tv" v-if="data.topicnType == '1'">
        <!-- 多选 -->
        <span v-for="(item, index) in data.questionAnswer" :key="index"
          ><span v-if="index > 0">,</span>{{ item.value }}</span
        >
      </div>
      <div class="tv pd" v-if="data.topicnType == '2'">
        <!-- 填空 -->
        <div
          :class="{ li: true }"
          v-for="(item, index) in data.questionAnswer"
          :key="index"
        >
          <div class="title">{{ item.title }}:</div>
          <div
            :class="{ 'li-va': true, ueditor: !isDisable, answer: isDisable }"
            v-html="item.htmlValue"
            @click="editQuestionStem('填空题答案', item.htmlValue, index)"
          ></div>
        </div>
      </div>
      <div class="tv" v-if="data.topicnType == '3'">
        <!-- 判断 -->
        <el-radio-group
          v-model="data.questionAnswer[0].value"
          class="div-flex-center div-flex-start"
        >
          <el-radio :label="'0'">
            <i class="el-icon-check"></i>
          </el-radio>
          <el-radio :label="'1'">
            <i class="el-icon-close"></i>
          </el-radio>
        </el-radio-group>
      </div>
      <div class="tv pd" v-if="data.topicnType == '4'">
        <!-- 简答题 -->
        <div class="li">
          <div
            :class="{ 'li-va': true, ueditor: true, answer: false }"
            v-html="data.questionAnswer[0].htmlValue"
            @click="
              editQuestionStem(
                '简答题答案',
                data.questionAnswer[0].htmlValue,
                -1
              )
            "
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "diy_dialog_question_details",
  props: {
    qId: {
      type: Object,
      default: {
        qId: "",
        type: "0", // 0 错题集  1 收藏夹
      },
    },
  },
  data() {
    return {
      id: this.qId.qId,
      type: this.qId.type,
      data: {
        topicnType: "0",
      },
    };
  },
  methods: {
    async showErrCollectDetails() {
      try {
        let resultData = await this.$request({
          url: "/errCollect/showErrCollectDetails",
          method: "post",
          data: { id: this.id },
        });
        this.data = JSON.parse(JSON.stringify(resultData));
        switch (this.data.topicnType) {
          case "0":
          case "3":
            // 单选
            this.data.answer =
              resultData.answer.length > 0 ? resultData.answer[0].value : "";
            break;
          case "1":
            this.data.answer = [];
            resultData.answer.forEach((element) => {
              this.data.answer.push(element.value);
            });
            break;

          default:
            break;
        }
      } catch (error) {
        this.$message({
          message: error.message,
          type: "warning",
          duration: 1000,
        });
      }
    },
  },
  async mounted() {
    await this.showErrCollectDetails();
  },
};
</script>

<style lang="less" scoped>
#question-details {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  padding: 10px;
  box-sizing: border-box;
  > .title {
    width: 100%;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    font-size: 16px;
    font-weight: bold;
  }
  > .question-title {
    width: 100%;
    height: auto;
    line-height: 30px;
    display: flex;
    align-items: center;
    > .nd {
      margin-left: 10px;
      font-size: 14px;

      .el-icon-star-off {
        font-size: 15px;
        color: #e9e9e9;
      }
      .el-icon-star-on {
        color: #ffe710;
        font-size: 17px;
      }
    }
  }
  > .xx {
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: column;
    padding: 0 20px;
    box-sizing: border-box;
    margin-top: 15px;
    .itel {
      width: 100%;
      height: auto;
      line-height: 30px;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      margin-bottom: 5px;
      font-size: 15px;
      /deep/ .el-radio__label {
        display: flex;
      }
    }
  }
  > .da,
  > .da1 {
    width: 100%;
    height: auto;
    display: flex;
    padding: 0 20px;
    box-sizing: border-box;
    margin-top: 20px;
    > .ti {
      width: auto;
      height: 40px;
      margin-right: 8px;
      font-size: 15px;
      font-weight: bold;
      margin: 10px 0;
      display: flex;
      align-items: center;
    }
    > .tv {
      width: 0;
      flex: 1;
      height: auto;
      min-height: 40px;
      display: flex;
      align-items: center;
      margin-left: 10px;
    }
    > .pd {
      flex-direction: column;
      > .li {
        width: 100%;
        height: 40px;
        display: flex;
        align-items: center;
        margin: 10px 0;
        .li-va {
          width: 0;
          height: 100%;
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: flex-start;
          padding: 0 10px;
          box-sizing: border-box;
        }
      }
    }
  }
  > .da1 {
    margin-top: 0px;
  }
  > .buts {
    width: 100%;
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 0 10px;
    box-sizing: border-box;
    > .but {
      width: auto;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 70px;
      box-sizing: border-box;
      margin: 0 15px;
      background-color: @baseColor;
      color: #fff;
      cursor: pointer;
    }
  }
}
</style>